import { QueryClientProvider } from '@tanstack/react-query';
import {
  AppRouter,
  GlobalTooltips,
  createAppQueryClient,
  ErrorBoundary,
  ScrollToTop,
  StyledToastContainer,
} from '@vgrubs/components';
import { installAdminPublicChatMock } from 'components/src/publicChat/mock/adminPublicChatMock';
import { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.min.css';
import { PUBLIC_CHAT_MOCK } from './adminPages/Chat/publicChatMock';
import { ROUTES_ADMIN } from './routes';

const queryClient = createAppQueryClient();

/* The Dispatcher and Website chat tabs answer from a local mock until their
   backend exists; it needs the client to push "socket" events into. */
if (PUBLIC_CHAT_MOCK) installAdminPublicChatMock(queryClient);

const App = () => {
  useEffect(() => {
    // Prevent browser from restoring scroll on popstate (back/forward); we restore manually per-route.
    if (typeof window !== 'undefined' && window.history?.scrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <ErrorBoundary context="AdminApp">
      <QueryClientProvider client={queryClient}>
        <StyledToastContainer />
        <GlobalTooltips />
        <ScrollToTop>
          <AppRouter routes={ROUTES_ADMIN} />
        </ScrollToTop>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
